// Die Quelle des Stichwort-Suchfelds, wo vergeben wird (Massenpflege, Vergabe
// am Kontakt): die Katalogsuche mit assignableOnly, damit nur vergebbare
// Stichworte vorgeschlagen werden (ein Vorschlag, den die Vergabe ablehnte,
// waere ein toter Vorschlag).

import type { AssignableTermView } from './classifications.ts';
import type { SendLike } from './command-client.ts';
import type { StichwortEintrag, StichwortTreffer } from './suche/stichwort-suchfeld.tsx';
import { MINIMUM_SEARCH_LENGTH, searchCatalog } from './taxonomy-catalog.ts';

export function alsEintrag(term: AssignableTermView): StichwortEintrag {
  return { id: term.taxonomyTermId, name: term.displayName, achse: term.taxonomyDisplayName, beschreibung: term.definition };
}

export async function searchAssignableEntries(options: {
  readonly baseUrl: string;
  readonly accessToken: () => Promise<string | undefined>;
  readonly onReauthenticate: () => void;
  readonly query: string;
  /** Die geladene erste Seite: sie traegt die Suche unter der Mindestlaenge. */
  readonly ersteSeite: readonly AssignableTermView[];
  readonly ersteSeiteGekuerzt: boolean;
  readonly send?: SendLike | undefined;
}): Promise<StichwortTreffer> {
  const query = options.query.trim();
  // Unter der Mindestlaenge lehnt die Katalogsuche ab; ein Zeichen sucht deshalb in der ersten Seite.
  if (query.length < MINIMUM_SEARCH_LENGTH) {
    const klein = query.toLocaleLowerCase('de-DE');
    return {
      art: 'geladen',
      eintraege: options.ersteSeite.filter((term) => term.displayName.toLocaleLowerCase('de-DE').includes(klein)).map(alsEintrag),
      gekuerzt: options.ersteSeiteGekuerzt,
    };
  }
  const token = await options.accessToken();
  if (token === undefined) {
    options.onReauthenticate();
    return { art: 'gestoert' };
  }
  const antwort = await searchCatalog({ baseUrl: options.baseUrl, accessToken: token, query, assignableOnly: true, ...(options.send ? { send: options.send } : {}) });
  if (antwort.outcome !== 'applied') return { art: 'gestoert' };
  return {
    art: 'geladen',
    eintraege: antwort.hits
      .filter((hit) => hit.inEffect && hit.endReasonCode === null && hit.termStatus !== 'draft')
      .map((hit) => ({
        id: hit.taxonomyTermId,
        name: hit.displayName,
        // Den Listennamen bringt der Treffer mit: gleiche Namen sind in verschiedenen Listen erlaubt.
        achse: hit.taxonomyDisplayName,
        beschreibung: hit.definition,
        // Traf das Getippte einen frueheren Namen, sagt der Baustein es an der Option.
        ...(hit.formerName === null ? {} : { frueher: hit.formerName }),
      })),
    gekuerzt: antwort.truncated,
  };
}
